/**
 * helpers to detect ie11 browser
 */
export const isFeatureSupport = (feature: string): boolean => {
    if (feature === 'pictureTag') {
        return !!(window as any).HTMLPictureElement;
    }
    return false;
};
